import { z } from 'zod';
import type { IDonationDetailsModel } from '@/types/screening/donation-details';
import { requireFields, yesNo, yesNoRequired } from '@utils/form-schema';

export const createDonationDetailsSchema = (
    model: Pick<IDonationDetailsModel, 'isReferral' | 'isLiver'>,
) => {
    return z
        .object({
            hasIntendedRecipient: yesNoRequired,
            ddRelationshipToPatient: z.string(),
            ddRecipFirstName: z.string(),
            ddRecipLastName: z.string(),
            ddKnowsRecipDob: yesNo,
            ddRecipDob: z.string(),
            recipientCenterId: z.string(),
            recipientAtSameDashCenter: yesNo,
        })
        .superRefine((data, ctx) => {
            // RequireDirectedDonorFields = HasIntendedRecipient && !Liver
            const requireDirected = data.hasIntendedRecipient === '1' && !model.isLiver;

            if (!requireDirected) return;

            requireFields(ctx, data, 'ddRelationshipToPatient', 'ddRecipFirstName', 'ddRecipLastName', 'ddKnowsRecipDob');

            if (data.ddKnowsRecipDob === '1') {
                requireFields(ctx, data, 'ddRecipDob');
            }

            // IsPrivateLabelDirectedDonor = !IsReferral → ask "at same center?"
            if (!model.isReferral) {
                requireFields(ctx, data, 'recipientAtSameDashCenter');
            }

            // IsDirectedDonorReferral = IsReferral || RecipientAtSameDashCenter == false → center required
            if (model.isReferral || data.recipientAtSameDashCenter === '0') {
                requireFields(ctx, data, 'recipientCenterId');
            }
        });
};
